/** Samma nyckel som i CookieBanner — lagras som JSON i localStorage */
export const COOKIE_CONSENT_KEY = 'byggfynd_cookie_consent';

export function getStoredConsent() {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** Statistik & analys (t.ex. rekommendationer baserat på beteende i webbläsaren) */
export function canUseStatistics() {
  const c = getStoredConsent();
  return Boolean(c?.statistics);
}

/** Marknadsföring (Meta Pixel m.m.) */
export function canUseMarketing() {
  const c = getStoredConsent();
  return Boolean(c?.marketing);
}
